import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { EWizardLinterStatus } from "../../../../../Shared/Process/Process/WizardLinter";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { QuoteInstructionStore } from "../../NewQuoteWizard/Store/Variable";

export class EWizardLinterHelper {
    static getEWizardLinterStatus(complete: boolean): EWizardLinterStatus {
        return complete ? EWizardLinterStatus.PleaseCheck : EWizardLinterStatus.PleaseComplete;
    }

    static shouldDisplay(type: SubAccountType): boolean {
        const quote = QuoteInstructionStore.getData();
        const quoteid = getQueryParameters()["quoteid"];
        if (quoteid == null || quote == null || quote.SelectedProducts == null) {return false;}
        const copyFromQuote = quote.SelectedProducts.findIndex((x) => x.SubAccountType == type) != -1;
        return copyFromQuote;
    }
}
